export default (values, totalInput) => {
  if (totalInput) {
    return Number(values.totalWattage)
  } else {
    return values.individualWattage * values.numberOfLights
  }
}
